import ContactInfo from './ContactInfo.container';

export default ContactInfo;
